var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 468,
    height: 469.493,
    viewBox: "0 0 468 469.493",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_66_1",
    "data-name": "Component 66 \\u2013 1",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_165748",
    "data-name": "Group 165748",
    transform: "translate(1382 -1635.816)",
    opacity: 0.297
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117551",
    "data-name": "Path 117551",
    d: "M619.025,636.417h0a28.552,28.552,0,0,1-28.552-28.552V463.21a28.552,28.552,0,0,1,57.1,0V607.864a28.552,28.552,0,0,1-28.552,28.552",
    transform: "translate(-1850.279 1291.107)",
    fill: "none",
    stroke: "#0e71f8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117552",
    "data-name": "Path 117552",
    d: "M1458.857,636.417h0a28.552,28.552,0,0,1-28.552-28.552V463.21a28.552,28.552,0,0,1,57.1,0V607.864a28.552,28.552,0,0,1-28.552,28.552",
    transform: "translate(-2516.315 1291.107)",
    fill: "none",
    stroke: "#0e71f8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117553",
    "data-name": "Path 117553",
    d: "M1040.17,291.709h0a28.552,28.552,0,0,1-28.552-28.552V28.554a28.552,28.552,0,0,1,57.1,0v234.6a28.552,28.552,0,0,1-28.552,28.552",
    transform: "translate(-2184.272 1635.814)",
    fill: "none",
    stroke: "#0e71f8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117554",
    "data-name": "Path 117554",
    d: "M359.036,1589.357h0a28.552,28.552,0,0,1,28.552-28.552h261.3a28.552,28.552,0,0,1,0,57.1h-261.3a28.552,28.552,0,0,1-28.552-28.552",
    transform: "translate(-1666.736 398.007)",
    fill: "none",
    stroke: "#0e71f8",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117555",
    "data-name": "Path 117555",
    d: "M0,2016.5H0a28.552,28.552,0,0,1,28.552-28.552h409.9a28.552,28.552,0,0,1,0,57.1H28.552A28.552,28.552,0,0,1,0,2016.5",
    transform: "translate(-1382 59.26)",
    fill: "none",
    stroke: "#0e71f8",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOutline);
export default __webpack_public_path__ + "static/media/logo-outline.033e58356178b103bb0768784fb03e61.svg";
export { ForwardRef as ReactComponent };